import {ApiRes} from '@type/api'
import {apiPost} from '@api/api'
import {IConfirmResponse} from '@api/auths/register/Register'

export const apiEditReferral = async (referralCode: string): Promise<ApiRes<IConfirmResponse>> => {
    return await apiPost('edit', {
        promo_code: referralCode,
    })
}
